import React from 'react';
import styles from './CheckBox.module.css';


export class CheckBox extends React.Component {

    onClick() {
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(!this.props.checked);
        }
    }

    render() {
        let cls;
        if (this.props.disabled) {
            cls = styles.checkbox_wrapper_disabled;
        } else {
            cls = styles.checkbox_wrapper_enabled;
        }

        if (this.props.className) {
            cls += ' ' + this.props.className;
        }

        let lblCls = styles.checkbox_label;
        if (this.props.labelClassName) {
            lblCls += ' ' + this.props.labelClassName;
        }

        return (
            <span className={cls}>
                <span className='container'>
                    <input type='checkbox' checked={this.props.checked} disabled={this.props.disabled} onChange={() => this.onClick()} />
                    {this.props.label &&
                        <span className={lblCls} title={this.props.title} onClick={() => this.onClick()}>{this.props.label}</span>
                    }
                </span>
            </span>


        );
    }
}

